export const PREPARATION_STAGES = ['not_started', 'form_filed', 'fee_paid', 'portal_ready'] as const;

export type PreparationStage = (typeof PREPARATION_STAGES)[number];

export interface VisaPreparation {
  stage: PreparationStage | null;
  consulting_requested: boolean;
}

export interface ConsultingOffer {
  cost_cents: number;
  currency: string;
  whatsapp_url: string;
}
